import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Socket } from 'socket.io-client';

export interface WebSocketSlice {
  socket: Socket | null;
}

const initialState: WebSocketSlice = {
  socket: null,
};

const webSocketSlice = createSlice({
  name: 'webSocketClient',
  initialState,
  reducers: {
    connect: (state) => state,
  },
});

export { webSocketSlice };
